 <template>
  <div>
    <v-toolbar flat color="white" class="pt-3">
      <v-btn color="primary" dark class="mb-2" @click="addItem()" round>ADD DEVICE</v-btn>
      <v-btn color="primary" round @click="exportDevices()"><v-icon>download</v-icon> Export</v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
        v-on:keyup.enter="$router.push({name: $route.name, query:{offset: $route.query.offset, records: $route.query.records, search: search}})"
      ></v-text-field>
    </v-toolbar>

    <!-- Single select locations table -->
    <v-dialog persistent v-model="locationSearch" width="80vw">
      <v-card>
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">SEARCH LOCATIONS</h1>
        </v-toolbar>
        <v-card-text>
          <v-layout wrap>
            <v-text-field
              v-model="search3"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              max-width="50px"
              class="pa-3"
              clearable
            ></v-text-field>
          </v-layout>
          <v-data-table
            v-model="selectedLocation"
            :headers="locationHeaders"
            :items="locations"
            :pagination.sync="pagination"
            select-all
            :loading="loading"
            :search="search3"
            item-key="id"
            class="elevation-1"
          >
            <template v-slot:headers="props">
              <tr>
                <th></th>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                  @click="changeSort(header.value)"
                >
                  <v-icon small>arrow_upward</v-icon>
                  {{ header.text }}
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr :active="props.item.flag" @click="clearAndSetLocationFlags(props.item.id)">
                <td></td>
                <td>
                  <v-checkbox :input-value="props.item.flag" primary hide-details></v-checkbox>
                </td>
                <td class="text-xs-center">{{props.item.unitNo}}</td>
                <td class="text-xs-center">{{props.item.erfNo}}</td>
                <td class="text-xs-center">{{props.item.otherNo}}</td>
                <td class="text-xs-center">{{props.item.complexStreetName}}</td>
                <td class="text-xs-center">{{props.item.subcomplexName}}</td>
                <td class="text-xs-center">{{props.item.complexName}}</td>
              </tr>
            </template>
          </v-data-table>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" round @click="locationSearch=false; selectedLocation=[]">Cancel</v-btn>
            <v-btn color="primary" round @click="locationSearch=false">Done</v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Single select upstream device table -->
    <v-dialog persistent v-model="deviceSearch" width="80vw">
      <v-card>
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">SEARCH DEVICES</h1>
        </v-toolbar>
        <v-card-text>
          <v-layout wrap>
            <v-text-field
              v-model="search2"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              max-width="50px"
              class="pa-3"
              clearable
            ></v-text-field>
          </v-layout>
          <v-data-table
            v-model="selectedDevice"
            :headers="headers"
            :items="upstreamDevices"
            :loading="loading"
            :pagination.sync="pagination"
            select-all
            :search="search2"
            item-key="id"
            class="elevation-1"
          >
            <template v-slot:headers="props">
              <tr>
                <th></th>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                  @click="changeSort(header.value)"
                >
                  <v-icon small>arrow_upward</v-icon>
                  {{ header.text }}
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr :active="props.item.flag" @click="clearAndSetDeviceFlags(props.item.id)">
                <td></td>
                <td>
                  <v-checkbox :input-value="props.item.flag" primary hide-details></v-checkbox>
                </td>
                <td class="text-xs-center">{{props.item.systemName}}</td>

             
                <td
                  class="text-xs-center"
                  v-if="props.item.deviceMakeModel"
                >{{props.item.deviceMakeModel.deviceMake.name}} {{props.item.deviceMakeModel.name}}</td>
                <td class="text-xs-center" v-else></td>
                <td class="text-xs-center">{{props.item.ipAddress}}</td>
                <td class="text-xs-center">{{props.item.serialNumber}}</td>
              
                <td class="text-xs-center">{{props.item.ponId}}</td>
                <td class="text-xs-center">{{props.item.frame}}</td>
                <td class="text-xs-center">{{props.item.slot}}</td>
                <td class="text-xs-center">{{props.item.port}}</td>
                <td class="text-xs-center">{{props.item.note}}</td>
                

              </tr>
            </template>
          </v-data-table>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn
                color="primary"
                round
                @click="deviceSearch=false; addButton=true; selectedDevice=[]"
              >Cancel</v-btn>
              <v-btn color="primary" round @click="deviceSearch=false">Done</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Add new item modal -->
    <v-dialog persistent v-model="newDialog" max-width="750px">
      <v-toolbar flat class="primary">
        <h1 class="headline white--text">ADD DEVICE</h1>
      </v-toolbar>
     
      <v-card flat>
        <v-card flat v-show="devicetab">
          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="editedItem.systemName" label="System Name" required></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="editedItem.ipAddress" label="IP Address" required></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="editedItem.serialNumber" label="Serial Number" required></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="editedItem.ponMac" label="Pon Mac"></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="editedItem.macAddress" label="Mac Address"></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-autocomplete
                    clearable
                    v-model="editedItem.deviceMakeModelId"
                    :items="deviceMakeModel"
                    hide-no-data
                    flat
                    color="primary"
                    label="*Device Make Model"
                    :item-text="item => item.deviceMake.name + ' | ' + item.name"
                    item-value="id"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-checkbox v-model="editedItem.inStock" label="In Stock" @change="editedItem.stockWarehouseId=null"></v-checkbox>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-autocomplete  ref="stockWarehouses" v-on:blur="$refs['stockWarehouses'].blur()" :items="stockWarehouses" item-text="name" item-value="id" :disabled="!editedItem.inStock" v-model="editedItem.stockWarehouseId" label="Warehouse"></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>

        <v-card flat v-show="additionalInformation">
          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex v-show="addButton" xs12 sm6 md6>
                  <v-btn
                    v-if=" this.selectedDevice.lenth==0 ||this.editedItem.upstreamDeviceId == null || typeof(this.editedItem.upstreamDeviceId) == 'undefined' || typeof(this.selectedDevice[0]) == 'undefined'"
                    color="primary"
                    round
                    @click="deviceSearch=true; selectedDevice=[]; addButton=false"
                  >Add Upstream Device</v-btn>
                </v-flex>

                <v-flex v-if="this.selectedDevice[0]" xs12 sm6 md6>
                  <v-text-field
                    v-model="selectedDevice[0].deviceMakeModel.name"
                    label="Upstream Device Make Model Name"
                    readonly
                    persistent-hint
                  ></v-text-field>
                  <v-btn
                    v-if="this.selectedDevice.length>0"
                    round
                    color="primary"
                    @click="deviceSearch=true"
                  >Edit Upstream Device</v-btn>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="editedItem.frame" label="Frame" type="number"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="editedItem.slot" label="Slot" type="number"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="editedItem.port" label="Port" type="number"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="editedItem.ponId" label="PON ID" type="number"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="editedItem.note" label="Note"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn color="primary" round @click="close">Cancel</v-btn>
            <v-btn v-if="editedItem.deviceMakeModelId" color="primary" round @click="saveNew">Save</v-btn>
            <v-btn v-else round disabled>Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Edit Modal -->
    <v-dialog persistent v-model="dialog" max-width="750px">
      <v-toolbar flat class="primary">
        <h1 class="headline white--text">EDIT DEVICE</h1>
      </v-toolbar>
      <v-toolbar flat color="white">
        <v-tabs>
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab
            @click="devicetab=true;additionalInformation=false; commenttab=false"
            class="grey--text"
            flat
            round
            color="grey"
          >Basic Information</v-tab>
          <v-tab
            @click="devicetab=false;additionalInformation=true; commenttab=false"
            class="grey--text"
            flat
            round
            color="grey"
          >Additional Information</v-tab>
          <v-tab
            @click="devicetab=false;additionalInformation=false; commenttab=true"
            class="grey--text"
            flat
            round
            color="grey"
          >Comments</v-tab>
        </v-tabs>
      </v-toolbar>
      <v-card flat>
        <v-card flat v-show="devicetab">
          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="editedItem.systemName" label="System Name" required></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="editedItem.ipAddress" label="IP Address" required></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="editedItem.serialNumber" label="Serial Number" required></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="editedItem.ponMac" label="Pon Mac"></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="editedItem.macAddress" label="Mac Address"></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="editedItem.ponNumerical" label="Pon Numerical"></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="editedItem.productNumber" label="Product Number"></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-autocomplete
                    clearable
                    v-model="editedItem.deviceMakeModelId"
                    :items="deviceMakeModel"
                    hide-no-data
                    flat
                    color="primary"
                    label="*Device Make Model"
                    :item-text="item => item.deviceMake.name + ' | ' + item.name"
                    item-value="id"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    label="Associated Location Type"
                    :items="['End Location','Location Network', 'Location Node', 'Switching Centre']"
                    item-text="name"
                    item-value="id"
                    v-model="associatedLocationType"
                  ></v-autocomplete>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md6
                  v-if="this.selectedLocation.length == 0&&associatedLocationType==='End Location'"
                >
                  <v-btn
                    color="primary"
                    round
                    v-if="this.selectedLocation.length == 0&&associatedLocationType==='End Location'"
                    @click="locationSearch=true"
                  >Add Location</v-btn>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md6
                  v-if="this.selectedLocation.length>0&&associatedLocationType==='End Location' && this.selectedLocation[0] !=null"
                >
                  <v-text-field
                    v-model="selectedLocation[0].locationDescription"
                    label="Location Description"
                    readonly
                  ></v-text-field>
                  <v-btn round color="primary" @click="locationSearch=true">Edit Location</v-btn>
                </v-flex>

                <v-flex xs12 sm6 md6 v-if="associatedLocationType==='Location Network'">
                  <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    label="Select Network"
                    :items="complexList"
                    item-text="name"
                    item-value="id"
                    v-model="locationNetworkId"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md6 v-if="associatedLocationType==='Location Node'">
                  <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    label="Select Node"
                    :items="locationNodeList"
                    item-text="name"
                    item-value="id"
                    v-model="locationNodeId"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md6 v-if="associatedLocationType==='Switching Centre'">
                  <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    label="Select Switching Centre"
                    :items="switchingCentreList"
                    item-text="name"
                    item-value="id"
                    v-model="switchingCentreId"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
        <v-card flat v-show="additionalInformation">
          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex v-if="addButton" xs12 sm6 md6>
                  <v-btn
                    color="primary"
                    round
                    @click="deviceSearch=true; selectedDevice=[]; this.addButton==false; addButtonFunc()"
                  >Add Upstream Device</v-btn>
                </v-flex>
                <v-flex
                  v-if="this.selectedDevice.length>0|| this.selectedDevice[0] || this.selectedDevice[0] !=null"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    v-model="selectedDevice[0].deviceMakeModel.name"
                    label="Upstream Device Make Model Name"
                    readonly
                    persistent-hint
                  ></v-text-field>
                  <v-btn round color="primary" @click="deviceSearch=true">Edit Upstream Device</v-btn>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="editedItem.frame" label="Frame" type="number"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="editedItem.slot" label="Slot" type="number"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="editedItem.port" label="Port" type="number"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="editedItem.ponId" label="PON ID" type="number"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="editedItem.note" label="Note"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>

        <v-card flat v-show="commenttab">
          <v-card-text>
            <v-toolbar flat class="white">
              <v-btn
                color="primary"
                dark
                class="mb-2"
                @click="clearComments(); addCommentDialog=true"
                round
              >ADD COMMENT</v-btn>
            </v-toolbar>
            <v-data-table
              :loading="loading"
              :headers="commentHeaders"
              :items="deviceComments"
              item-key="id"
            >
              <template v-slot:items="props">
                <td class="justify-center layout px-0">
                  <v-icon small @click=" editComment(props.item)">edit</v-icon>
                  <v-icon small @click="deleteComment(props.item.id)">delete</v-icon>
                </td>
                <td class="text-xs-center">{{formatDate(props.item.dateTimeStamp)}}</td>
                <td
                  class="text-xs-center"
                >{{props.item.contact.name + ' ' + props.item.contact.surname}}</td>
                <td class="text-xs-center">{{props.item.comments}}</td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>

        <v-card-actions>
          <v-layout justify-center>
            <v-btn color="primary" round @click="close">Cancel</v-btn>
            <v-btn color="primary" round @click="save">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Add Comment -->
    <v-dialog persistent v-model="addCommentDialog" max-width="750px">
      <v-card>
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">ADD COMMENT</h1>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12>
                <v-textarea v-model="editedCommentItem.comments" label="Comments" persistent-hint></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-layout justify-center>
            <v-btn color="primary" round @click="addCommentDialog=false">Cancel</v-btn>
            <v-btn color="primary" round @click="addComment()">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Edit Comment -->
    <v-dialog persistent v-model="editCommentDialog" max-width="750px">
      <v-card>
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">EDIT COMMENT</h1>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12>
                <v-textarea v-model="editedCommentItem.comments" label="Comments" persistent-hint></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-layout justify-center>
            <v-btn color="primary" round @click="editCommentDialog=false">Cancel</v-btn>
            <v-btn color="primary" round @click="saveComment()">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

    <v-dialog persistent v-model="deviceGraphModal">
      <v-card>
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">DEVICE GRAPHS</h1>
        </v-toolbar>
        <img :src="deviceGraph" alt="Graph" />
        <v-card flat>
          <v-card flat>
            <v-card-text>
              <v-container grid-list-xs>
                <v-layout wrap>
                  <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    :items="deviceGraphTypes"
                    item-text="name"
                    item-value="id"
                    v-model="deviceGraphType"
                    label="Select a Graph Type"
                  ></v-autocomplete>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>

          <v-card-actions>
            <v-layout justify-center>
              <small>*indicates required field</small>
              <v-btn color="primary" round @click="close">Cancel</v-btn>
              <v-btn color="primary" round @click="save">Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-card>
    </v-dialog>
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :loading="isloading"
      :items="devices"
      :search="searchTrigger"
      :rows-per-page-items="[20, 50, 100, 250]"
      :pagination.sync="pagination"
      item-key="id"
      align-center
      style="cursor: pointer"
      hide-actions
    >
      <template v-slot:items="props">
        <td class="text-xs-center">
          <v-layout justify-center>
            <!-- <v-icon
            small
            @click="editItem(props.item)"
            >edit</v-icon>-->
            <v-icon @click="deleteItem(props.item.id)">delete</v-icon>
            <!-- <v-icon @click="viewDeviceDetails(props.item)">remove_red_eye</v-icon> -->
            <!-- <v-icon v-if="props.item.deviceMakeModel&&props.item.deviceMakeModel.deviceType.name==='OLT'">build</v-icon> -->
          </v-layout>
        </td>
        <!-- <td class="text-xs-center" @click="viewDeviceDetails(props.item)">
          <v-icon v-if="props.item.isOnline" color="light-green">circle</v-icon>
          <v-icon v-else-if="props.item.isOnline == false" color="red">circle</v-icon>
        </td> -->

        <td class="text-xs-center" @click="viewDeviceDetails(props.item)">{{props.item.systemName}}</td>
        <td
          @click="viewDeviceDetails(props.item)"
          class="text-xs-center"
          v-if="props.item.deviceMakeModel"
        >{{props.item.deviceMakeModel.deviceMake.name}} {{props.item.deviceMakeModel.name}}</td>
        <td @click="viewDeviceDetails(props.item)" class="text-xs-center" v-else></td>
        <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.ipAddress}}</td>
        <td
          @click="viewDeviceDetails(props.item)"
          class="text-xs-center"
        >{{props.item.serialNumber}}</td>
        <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.ponMac}}</td>
        <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.softwareVersion}}</td>
        <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.ponId}}</td>
        <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.frame}}</td>
        <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.slot}}</td>
        <td @click="viewDeviceDetails(props.item)" class="text-xs-center">{{props.item.port}}</td>
        <td @click="viewDeviceDetails(props.item)" class="text-xs-center longText">{{props.item.note}}</td>
        <td class="text-xs-center">
                  <v-chip v-if="props.item.acsDevice">ACS</v-chip>
                  <v-chip v-if="props.item.isU2000">U2000</v-chip>
                  <v-chip v-if="props.item.Handle_ID">Zhone</v-chip></td>
      </template>

      <!-- Custom Row count and Paging text -->
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ totalitems }}</template>
    </v-data-table>
    <div class="text-xs-center pt-2 white" :key="$route.query.offset">
      <v-layout wrap>
        <!-- <v-flex xs12 mb-3>
          <span
            style="color: grey"
          >item {{parseInt($route.query.offset) + 1}}-{{parseInt($route.query.offset) + parseInt($route.query.records)}} of {{pagination.totalItems}}</span>
        </v-flex> -->
        <v-flex xs12>
          <v-pagination
            v-model="page"
            :length="Math.ceil(pagination.totalItems/pagination.rowsPerPage)"
            :total-visible="7"
          ></v-pagination>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import Api from "@/services/Api";
import dateformat from "dateformat";

export default {
  props: ["devices", "totalitems", "isloading"],
  data() {
    return {
      minimumDate: "",
      page: 1,
      editCommentDialog: false,
      addCommentDialog: false,
      addButton: false,
      devices: [],
      search3: "",
      search2: "",
      commenttab: false,
      deviceComments: [],
      selectedDeviceSearch: false,
      selectedDevice: [],
      deviceSearch: false,
      upstreamDevices: [],
      additionalInformation: false,
      switchingCentreList: [],
      locations: [],
      locationtab: false,
      associatedLocationType: "",
      devicetab: false,
      showDetails: true,
      loading: false,
      expand: false,
      search: "",
      totalItems: null,
      IPAddress: "",
      deviceGraph: "",
      complexList: [{ name: "" }],
      dialog: false,
      newDialog: false,
      locationNetworkId: null,
      deviceGraphType: null,
      deviceGraphTypes: [],
      locationNodeList: [{ name: "" }],
      locationNodeId: null,
      switchingCentreId: null,
      selectedLocation: [],
      deviceIdArray: [],
      locationSearch: false,
      editLocationButton: false,
      deviceGraphModal: false,
      libreDevices: [],
      pagination: { totalItems: 0, page: this.page },
      searchTrigger: "",
      stockWarehouses: [],
      locationHeaders: [
        { text: "Action", align: "center" },
        { text: "Unit No", align: "center", value: "unitNo" },
        { text: "Erf No", align: "center", value: "erfNo" },
        { text: "Other No", align: "center", value: "otherNo" },
        {
          text: "Complex Street Name",
          align: "center",
          value: "complexStreetName"
        },
        { text: "Sub Complex", align: "center", value: "subComplexName" },
        { text: "Estate", align: "center", value: "complexName" }
      ],
      commentHeaders: [
        {
          text: "Action",
          align: "center"
        },
        {
          text: "Date Time Stamp",
          align: "center",
          value: "dateTimeStamp"
        },
        {
          text: "Commenter",
          align: "center",
          value: "contact"
        },
        {
          text: "Comments",
          align: "center",
          value: "comments",
          width: "100%"
        }
      ],
      headers: [
        {
          text: "Action",
          align: "center"
        },
        {
          text: "System Name",
          align: "center",
          value: "systemName"
        },
       
        {
          text: "Model",
          align: "center",
          value: "deviceMakeModel.name"
        },
        {
          text: "IP Address",
          align: "center",
          value: "ipAddress"
        },
        {
          text: "Serial Number",
          align: "center",
          value: "serialNumber"
        },
        {
          text: "Pon Mac/ FSAN",
          align: "center",
          value: "ponMac"
        },
        {
          text: "Software Version",
          align: "center",
          value: "softwareVersion"
        },
      
        {
          text: "PON ID",
          align: "center",
          value: "ponId"
        },
        {
          text: "Frame",
          align: "center",
          value: "frame"
        },
        {
          text: "Slot",
          align: "center",
          value: "slot"
        },
        {
          text: "Port",
          align: "center",
          value: "port"
        },
        {
          text: "Note",
          align: "center",
          value: "note"
        },
        {
          text: "Monitoring",
          align: "center",
          sortable: false
        }
      ],
      deviceMakeModel: [],
      location: [],
      editedIndex: -1,
      editedItem: {
        serialNumber: "",
        ponMac: "",
        macAddress: "",
        ponNumerical: "",
        productNumber: "",
        deviceMakeModel: [],
        deviceMakeModelId: null,
        ipAddress: "",
        systemName: "",
        location: "",
        locationId: null,
        port: null,
        frame: null,
        slot: null,
        upstreamDeviceId: null,
        ponId: null,
        note: "",
        isActive: true,
        isDeleted: false
      },
      defaultItem: {
        serialNumber: "",
        ponMac: "",
        macAddress: "",
        ponNumerical: "",
        productNumber: "",
        deviceMakeModel: [],
        deviceMakeModelId: "",
        ipAddress: "",
        systemName: "",
        location: "",
        locationId: null,
        port: null,
        frame: null,
        slot: null,
        upstreamDeviceId: null,
        ponId: null,
        note: "",
        isActive: true,
        isDeleted: false
      },
      editedCommentItem: {
        deviceId: null,
        contactId: null,
        comments: "",
        dateTimeStamp: "",
        isActive: true,
        isDeleted: false
      }
    };
  },

  computed: {
    // searchTrigger(){
    //   if (this.search.length >= 3) {
    //      return this.search
    //   } else {
    //     return null
    //   }
    // }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    locationNetworkId() {
      if (typeof this.complexList[this.locationNetworkId] !== "undefined") {
        this.locationNodeId = this.complexList[
          this.locationNetworkId
        ].locationNode.id;
      }
    },
    totalitems(value) {
      if (value && value != null && value != "") {
        this.pagination.totalItems = value;
      } else {
        this.pagination.totalItems = 0;
      }
    },
    "pagination.rowsPerPage": {
      immediate: true,
      handler(value) {
        if (value && value != "" && value != this.$route.query.records) {
          if (this.$route.query.search) {
            this.$router.push({
              name: this.$route.name,
              query: {
                offset: this.$route.query.offset,
                records: value,
                search: this.$route.query.search
              }
            });
          } else {
            this.$router.push({
              name: this.$route.name,
              query: { offset: this.$route.query.offset, records: value }
            });
          }
        }
      }
    },
    "pagination.page": {
      immediate: true,
      handler(value) {
        // if(value&&value!=""){
        //   debugger
        //   if(this.$route.query.search){
        //     debugger
        //     this.$router.push({name: this.$route.name, query:{offset: (value-1)*this.$route.query.records, records: this.$route.query.records, search: this.$route.query.search}})
        //   } else {
        //     this.$router.push({name: this.$route.name, query:{offset: (value-1)*this.$route.query.records, records: this.$route.query.records}})
        // }
        // }
      }
    },
    page(value) {
      this.pagination.page = this.page;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.search) {
          this.$router.push({
            name: this.$route.name,
            query: {
              offset: (value - 1) * this.$route.query.records,
              records: this.$route.query.records,
              search: this.$route.query.search
            }
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              offset: (value - 1) * this.$route.query.records,
              records: this.$route.query.records
            }
          });
        }
      }
    }
  },

  created() {    
    this.pagination.totalItems = this.totalitems;
    this.initialize();
  },

  methods: {
    // showDeviceGraphs(item){
    //   this.editedItem=Object.assign({}, item);
    //   // this.deviceGraphModal=true
    //   // Api()
    //   // .get('/')
    //   this.IPAddress=
    //    Api()
    //   .get('/integrations/byName/LibreNMS')
    //   .then(response=>{
    //     Api()
    //     .get('/libre/deviceGraph',{
    //       params:{
    //         apiurl: response.data.apiUrl,
    //         apitoken: response.data.token,
    //         graphType: 'device_poller_perf',
    //         ipAddress: '10.27.145.130'
    //       }
    //     }).then(response=>{
    //       // console.log(response.data)
    //       console.log(response)
    //       this.deviceGraph=response.data.body
    //       // console.log(this.deviceGraph)
    //       // 'data:image/png;base64,'.concat(this.deviceGraph.concat(response.data))

    //       // this.deviceGraph=response.data
    //     }).then(this.deviceGraphModal=true)
    // })},
    async massLocationUpdate() {
      for (let i = 0; i < this.devices.length; i++) {
        if (
          this.devices[i].locationId !== null &&
          this.devices[i].locationNetworkId === null
        ) {
          Api().put("/devices/" + this.devices[i].id, {
            locationNetworkId: this.devices[i].location.locationNetworkId
          });
        }
        if (
          this.devices[i].locationNetworkId !== null &&
          this.devices[i].locationNodeId === null
        ) {
          Api().put("/devices/" + this.devices[i].id, {
            locationNodeId: this.devices[i].locationNetwork.locationNodeId
          });
        }
        if (
          this.devices[i].locationNodeId !== null &&
          this.devices[i].switchingCentreId === null
        ) {
          Api().put("/devices/" + this.devices[i].id, {
            switchingCentreId: this.devices[i].locationNode.switchingCentreId
          });
        }
      }
    },
    viewDeviceDetails(item) {
      this.$router.push({ path: "/devices/" + item.id });
    },
    syncLibreDevices() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.deviceIdArray = [];
        Api()
          .get("/integrations/byName/LibreNMS")
          .then(response => {
            Api()
              .get("/libre/allDevices", {
                params: {
                  apiurl: response.data.apiUrl,
                  apitoken: response.data.token
                }
              })
              .then(async response => {
                this.libreDevices = response.data.devices;
                await Api()
                  .get("/devices")
                  .then(async response => {
                    for (let x = 0; x < response.data.length; x++) {
                      let exists = false;
                      if (
                        !this.deviceIdArray.includes(
                          response.data[x].libreDeviceId
                        )
                      ) {
                        this.deviceIdArray.push(response.data[x].libreDeviceId);
                      }
                    }
                    for (let i = 0; i < this.libreDevices.length; i++) {
                      let exists = false;
                      for (let y = 0; y < this.deviceIdArray.length; y++) {
                        if (
                          this.deviceIdArray[y] ===
                          this.libreDevices[i].device_id
                        ) {
                          exists = true;
                        }
                      }
                      if (!exists) {
                        if (this.libreDevices[i].ip === "") {
                          this.IPAddress = this.libreDevices[i].hostname;
                        } else {
                          this.IPAddress = this.libreDevices[i].ip;
                        }

                        await Api().post("/devices", {
                          systemName: this.libreDevices[i].sysName,
                          libreDeviceId: this.libreDevices[i].device_id,
                          serialNumber: this.libreDevices[i].serial,
                          ponMac: null,
                          macAddress: null,
                          ponNumerical: null,
                          productNumber: null,
                          deviceMakeModelId: null,
                          locationId: null,
                          locationNetworkId: null,
                          locationNodeId: null,
                          ipAddress: this.IPAddress,
                          isDeleted: false,
                          isActive: true
                        });
                      }
                    }
                  });
              });
          });
      }
    },
    exportDevices(){
        Api()
        .get("/devices/export").then(response=>{
          var hiddenElement = document.createElement('a');
          hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(response.data);
          hiddenElement.target = '_blank';
          hiddenElement.download = 'devices.csv';
          hiddenElement.click();
        })
    },
    fetchDate() {
      this.editedCommentItem.dateTimeStamp = new Date()
        .toISOString()
        .substr(0, 10);
      return this.formatDate(this.editedCommentItem.dateTimeStamp);
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "dd/mm/yyyy");
      } else {
        null;
      }
    },

    clearAndSetLocationFlags(id) {
      this.selectedLocation = [];
      for (let i = 0; i < this.locations.length; i++) {
        this.locations[i].flag = false;
        if (this.locations[i].id == id) {
          this.locations[i].flag = true;
          this.selectedLocation = [];
          this.selectedLocation.push(this.locations[i]);
        }
      }
    },
    clearAndSetDeviceFlags(id) {
      this.selectedDevice = [];
      for (let i = 0; i < this.upstreamDevices.length; i++) {
        this.upstreamDevices[i].flag = false;
        if (this.upstreamDevices[i].id == id) {
          this.upstreamDevices[i].flag = true;
          this.selectedDevice = [];
          this.selectedDevice.push(this.upstreamDevices[i]);
        }
      }
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    cancelFields() {
      (this.associatedLocationType = ""),
        (this.switchingCentreId = null),
        (this.locationNodeId = null),
        (this.locationNetworkId = null),
        (this.editedItem.locationId = null),
        (this.selectedLocation = []),
        (this.selectedDevice = []);

      this.editedItem = {};
    },
    clearComments() {
      (this.editedCommentItem.contactId = null),
        (this.editedCommentItem.dateTimeStamp = ""),
        (this.editedCommentItem.comments = ""),
        (this.editedCommentItem.deviceId = null);
    },
    fetchUpstreamDevices() {
      // (this.loading = true)
        // Api()
        //   .get("/devices/active")
        //   .then(response => {
        //     this.upstreamDevices = response.data;
        //     this.loading = false;
        //   });
    },
    addComment() {
      let proceed = true;

      if (this.editedCommentItem.comments == "") {
        proceed = false;
        confirm("Please enter a comment.");
      }
      this.fetchDate();
      if (proceed == true) {
        Api()
          .post("/deviceComments", {
            contactId: this.$store.state.user.id,
            dateTimeStamp: this.editedCommentItem.dateTimeStamp,
            comments: this.editedCommentItem.comments,
            deviceId: this.editedItem.id,
            isDeleted: this.editedCommentItem.isDeleted,
            isActive: this.editedCommentItem.isActive
          })
          .then(response => {
            this.fetchComments(this.editedItem.id);
          });
        this.addCommentDialog = false;
      }
    },
    editComment(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.fetchComments(this.editedItem.id);
        this.editedCommentItem = Object.assign({}, item);
        this.editCommentDialog = true;
      }
    },
    saveComment() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        let proceed = true;

        if (this.editedCommentItem.comments == "") {
          proceed = false;
          confirm("Please enter a comment.");
        }
        this.fetchDate();
        if (proceed == true) {
          Api()
            .put("/deviceComments/" + this.editedCommentItem.id, {
              contactId: this.$store.state.user.id,
              dateTimeStamp: this.editedCommentItem.dateTimeStamp,
              comments: this.editedCommentItem.comments,
              deviceId: this.editedItem.id,
              isDeleted: this.editedCommentItem.isDeleted,
              isActive: this.editedCommentItem.isActive
            })
            .then(response => {
              this.fetchComments(this.editedItem.id);
            });
          this.editCommentDialog = false;
        }
      }
    },
    addItem() {
      if (this.authCreate(this.$store.state.currentRoute)) {
        this.locationtab = false;
        this.newDialog = true;
        this.devicetab = true;
        this.additionalInformation = false;
        this.commenttab = false;
        this.addButton = true;
        this.cancelFields();
      }
    },
    deleteComment(id) {
      if (this.authDelete(this.$store.state.currentRoute)) {
        confirm("Are you sure you want to delete this item?") &&
          Api()
            .put("/deviceComments/" + id, {
              isActive: false,
              isDeleted: true
            })
            .then(response => {
              this.fetchComments(this.editedItem.id);
              this.initialize();
            });
      }
    },
    fetchComments(id) {
      (this.loading = true),
        Api()
          .get("/deviceComments/findbyDevice/" + id)
          .then(response => {
            this.deviceComments = response.data.sort((a, b) =>
              a.dateTimeStamp < b.dateTimeStamp ? 1 : -1
            );
            this.loading = false;
          });
    },
    fetchDeviceMakeModels() {
      Api()
        .get("/deviceMakeModels/active")
        .then(response => {
          this.deviceMakeModel = response.data;
        });
    },
    fetchLocations() {
      this.loading = true;
      Api()
        .get("/locations/active")
        .then(response => {
          this.locations = response.data;
          this.totalItems = this.locations.length;
          this.loading = false;
        });
    },
    fetchLocationNetworks() {
      Api()
        .get("/locationNetworks/active")
        .then(response => {
          this.complexList = response.data;
        });
    },
    fetchLocationNodes() {
      Api()
        .get("/locationNodes/active")
        .then(response => {
          this.locationNodeList = response.data;
        });
    },
    fetchSwitchingCentres() {
      Api()
        .get("/switchingCentres/active")
        .then(response => {
          this.switchingCentreList = response.data;
        });
    },
    initialize() {
      this.pagination.totalItems = this.totalitems;
      this.page = 1;
      this.fetchDeviceMakeModels();
      this.fetchStockWarehouses()
      // this.fetchUpstreamDevices();
      // this.fetchDeviceMakeModels();
      // this.fetchLocations();
      // this.fetchLocationNetworks();
      // this.fetchLocationNodes();
      // this.fetchSwitchingCentres();
      // this.locationstab=false;
      // this.fetchDate();
    },
    fetchStockWarehouses(){
      Api().get('/stockWarehouse').then(res=>{
        this.stockWarehouses = res.data
      })
    },
    editItem(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.editLocationButton = true;
        this.dialog = true;
        this.devicetab = true;
        this.additionalInformation = false;
        this.commenttab = false;
        this.locationtab = false;
        this.fetchComments(item.id);
        this.editedItem = Object.assign({}, item);
        this.editedItem.upstreamDeviceId = null;
        this.selectedDevice = [];

        if (
          typeof this.selectedLocation[0] == "undefined" ||
          this.selectedLocation.length == 0
        ) {
          this.selectedLocation = [
            { locationDescription: "No Location Allocated" }
          ];
        } else if (
          this.selectedLocation.length > 0 ||
          typeof this.selectedLocation[0] != "undefined"
        ) {
          this.selectedLocation = [item.location];
        }
        if (item.upstreamDeviceId !== null) {
          this.addButton = false;
          this.editedItem.upstreamDeviceId = item.upstreamDeviceId;
          Api()
            .get(
              "/devices/searchByUpstreamDevice/" +
                this.editedItem.upstreamDeviceId
            )
            .then(response => {
              this.selectedDevice[0] = response.data[0];
              return;
            });
        } else {
          this.addButton = true;
        }

        if (this.editedItem.locationId !== null) {
          this.associatedLocationType = "End Location";
        } else if (this.editedItem.locationNetworkId !== null) {
          this.associatedLocationType = "Location Network";
        } else if (this.editedItem.locationNodeId !== null) {
          this.associatedLocationType = "Location Node";
        } else if (this.editedItem.switchingCentreId !== null) {
          this.associatedLocationType = "Switching Centre";
        }

        (this.locationNetworkId = item.locationNetworkId),
          (this.locationNodeId = item.locationNodeId),
          (this.switchingCentreId = item.switchingCentreId),
          (this.dialog = true);
      }
    },

    fetchDevices() {
      this.isLoading = true;
      Api()
        .get("/devices/active")
        .then(response => {
          this.devices = response.data;
          this.isLoading = false;
        });
    },
    deleteItem(id) {
      if (this.authDelete(this.$store.state.currentRoute)) {
        confirm("Are you sure you want to delete this item?") &&
          Api()
            .put("/devices/" + id, {
              isActive: false,
              isDeleted: true
            })
            .then(response => {
              this.fetchDevices(), this.initialize();
            });
      }
    },

    close() {
      this.dialog = false;
      this.newDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    addButtonFunc() {
      this.addButton = false;
    },
    save() {
      if (typeof this.selectedDevice[0] != "undefined") {
        this.editedItem.upstreamDeviceId = this.selectedDevice[0].id;
      }

      if (this.associatedLocationType == "End Location") {
        this.editedItem.locationId = this.editedItem.location.id;
        Api()
          .get("/locations/" + this.editedItem.locationId)
          .then(response => {
            this.locationNetworkId = response.data[0].locationNetworkId;
            this.locationNodeId =
              response.data[0].locationNetwork.locationNodeId;
            this.switchingCentreId =
              response.data[0].locationNetwork.locationNode.switchingCentreId;
          });
      }
      if (this.associatedLocationType == "Location Network") {
        Api()
          .get("/locationNetworks/" + this.locationNetworkId)
          .then(response => {
            this.locationNodeId = response.data[0].locationNodeId;
            this.switchingCentreId =
              response.data[0].locationNode.switchingCentreId;
          });
        this.editedItem.locationId = null;
      }
      if (this.associatedLocationType == "Location Node") {
        Api()
          .get("/locationNodes/" + this.locationNodeId)
          .then(response => {
            this.switchingCentreId = response.data[0].switchingCentreId;
          });
        (this.locationNetworkId = null), (this.editedItem.locationId = null);
      }
      if (this.associatedLocationType == "Switching Centre") {
        (this.locationNodeId = null),
          (this.locationNetworkId = null),
          (this.editedItem.locationId = null);
      }
      let proceed = true;
      if (
        this.editedItem.deviceMakeModelId == null ||
        typeof this.editedItem.deviceMakeModelId === "undefined"
      ) {
        proceed = false;
        confirm("Please select a device make model.");
      }
      if (
        this.associatedLocationType == "Location Network" &&
        this.locationNetworkId == null
      ) {
        proceed = false;
        confirm("Please select a location network.");
      }
      if (
        this.associatedLocationType == "Location Node" &&
        this.locationNodeId == null
      ) {
        proceed = false;
        confirm("Please select a location node.");
      }
      if (
        this.associatedLocationType == "Switching Centre" &&
        this.switchingCentreId == null
      ) {
        proceed = false;
        confirm("Please select a switching centre.");
      }
      if (
        this.editedItem.locationId == null &&
        this.locationNetworkId == null &&
        this.locationNodeId == null &&
        this.switchingCentreId == null
      ) {
        this.switchingCentreId = this.$route.params.switchingCentreId;
      }
      if (proceed == true) {
        Api()
          .put("/devices/" + this.editedItem.id, {
            systemName: this.editedItem.systemName,
            ipAddress: this.editedItem.ipAddress,
            serialNumber: this.editedItem.serialNumber,
            ponMac: this.editedItem.ponMac,
            macAddress: this.editedItem.macAddress,
            ponNumerical: this.editedItem.ponNumerical,
            productNumber: this.editedItem.productNumber,
            deviceMakeModelId: this.editedItem.deviceMakeModelId,
            locationId: this.editedItem.locationId,
            locationNetworkId: this.locationNetworkId,
            locationNodeId: this.locationNodeId,
            switchingCentreId: this.switchingCentreId,
            port: this.editedItem.port,
            slot: this.editedItem.slot,
            frame: this.editedItem.frame,
            note: this.editedItem.note,
            upstreamDeviceId: this.editedItem.upstreamDeviceId,
            ponId: this.editedItem.ponId,
            isDeleted: this.editedItem.isDeleted,
            isActive: this.editedItem.isActive
          })
          .then(response => {
            if (this.editedItem.locationId !== null) {
              Api().put("/locations/" + this.editedItem.locationId, {
                equipmentInstalled: true,
                fibrePulled: true
              });
            }
            this.fetchDevices();
          });
        this.close();
        this.locationtab = false;
      }
    },
    saveNew() {
      // if (typeof this.selectedDevice[0] != "undefined") {
      //   this.editedItem.upstreamDeviceId = this.selectedDevice[0].id;
      // }

      // if (this.associatedLocationType == "End Location") {
      //   this.editedItem.locationId = this.selectedLocation[0].id;
      //   Api()
      //     .get("/locations/" + this.editedItem.locationId)
      //     .then(response => {
      //       this.locationNetworkId = response.data[0].locationNetworkId;
      //       this.locationNodeId =
      //         response.data[0].locationNetwork.locationNodeId;
      //       this.switchingCentreId =
      //         response.data[0].locationNetwork.locationNode.switchingCentreId;
      //     });
      // } else if (this.associatedLocationType == "Location Network") {
      //   Api()
      //     .get("/locationNetworks/" + this.locationNetworkId)
      //     .then(response => {
      //       this.locationNodeId = response.data[0].locationNodeId;
      //       this.switchingCentreId =
      //         response.data[0].locationNode.switchingCentreId;
      //     });
      //   this.editedItem.locationId = null;
      // } else if (this.associatedLocationType == "Location Node") {
      //   Api()
      //     .get("/locationNodes/" + this.locationNodeId)
      //     .then(response => {
      //       this.switchingCentreId = response.data[0].switchingCentreId;
      //     });
      //   (this.locationNetworkId = null), (this.editedItem.locationId = null);
      // } else if (this.associatedLocationType == "Switching Centre") {
      //   (this.locationNodeId = null),
      //     (this.locationNetworkId = null),
      //     (this.editedItem.locationId = null);
      // }

      let proceed = true;
      if (this.editedItem.deviceMakeModelId == null) {
        proceed = false;
        confirm("Please select a device make model.");
      }
      if (
        this.associatedLocationType == "Location Network" &&
        this.locationNetworkId == null
      ) {
        proceed = false;
        confirm("Please select a location network.");
      }
      if (
        this.associatedLocationType == "Location Node" &&
        this.locationNodeId == null
      ) {
        proceed = false;
        confirm("Please select a location node.");
      }
      if (
        this.associatedLocationType == "Switching Centre" &&
        this.switchingCentreId == null
      ) {
        proceed = false;
        confirm("Please select a switching centre.");
      }
      if (
        this.editedItem.locationId == null &&
        this.locationNetworkId == null &&
        this.locationNodeId == null &&
        this.switchingCentreId == null
      ) {
        this.switchingCentreId = this.$route.params.switchingCentreId;
      }
      if (proceed == true) {
        Api()
          .post("/devices", {
            systemName: this.editedItem.systemName,
            ipAddress: this.editedItem.ipAddress,
            serialNumber: this.editedItem.serialNumber,
            ponMac: this.editedItem.ponMac,
            macAddress: this.editedItem.macAddress,
            ponNumerical: this.editedItem.ponNumerical,
            productNumber: this.editedItem.productNumber,
            deviceMakeModelId: this.editedItem.deviceMakeModelId,
            locationId: this.editedItem.locationId,
            locationNetworkId: this.locationNetworkId,
            locationNodeId: this.locationNodeId,
            switchingCentreId: this.switchingCentreId,
            port: this.editedItem.port,
            slot: this.editedItem.slot,
            frame: this.editedItem.frame,
            note: this.editedItem.note,
            upstreamDeviceId: this.editedItem.upstreamDeviceId,
            inStock: this.editedItem.inStock,
            stockWarehouseId: this.editedItem.stockWarehouseId,
            ponId: this.editedItem.ponId,
            isDeleted: this.editedItem.isDeleted,
            isActive: this.editedItem.isActive
          })
          .then(response => {
            if (this.editedItem.locationId !== null) {
              Api().put("/locations/" + this.editedItem.locationId, {
                equipmentInstalled: true,
                fibrePulled: true
              });
            }
            this.viewDeviceDetails(response.data);
            // this.fetchDevices();
          });
        this.close();
        this.locationtab = false;
      }
    }
  }
};
</script>
<style scoped>
.longText {
  display: block;
  width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  size: 15px;
}
</style>
